import { messstelle, kenngroesse } from './../../../utils/apiTypes';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState, AppDispatch } from "../../../app/store";
import { colNameType, kenngroesseDetailPqIndex, pqIndexResult, pqIndexResultForKenngroesse } from "./pqIndexTypes";
import { postJsonWithAuth } from "../../../utils/api";
import { logError, convertDateToWeekNumber } from "../../../utils/utils";
import { errorHandler } from '../../../utils/errorHandling';

const initialState: kenngroesseDetailPqIndex
  = {
  kenngroesseDetailUw: [],
  kenngroesseDetailZeit: [],
  loadingKenngroesseDetailUw: false,
  loadingKenngroesseDetailZeit: false,
}

const kenngroesseDetailPqIndexSlice = createSlice({
  name: "kenngroesseDetailPqIndex",
  initialState,
  reducers:
  {
    setKenngroesseDetailZeit: (state, action: PayloadAction<{
      kenngroesseName: string,
      kategorieName: string;
      liste_headerArray: Array<colNameType>;
      liste_horizentalArray: Array<number>;
      liste_vertikalArray: Array<number>;
      min_allNumber: number;
      pqIndexArray: Array<Array<pqIndexResult>>;
      isOld: boolean
    }>) => {
      const value: pqIndexResultForKenngroesse = {
        kenngroesse: action.payload.kenngroesseName,
        kategorie: action.payload.kategorieName,
        liste_header: action.payload.liste_headerArray,
        liste_horizental: action.payload.liste_horizentalArray,
        liste_vertikal: action.payload.liste_vertikalArray,
        min_all: action.payload.min_allNumber,
        pqIndex: action.payload.pqIndexArray,
        isOld: action.payload.isOld
      };
      state.kenngroesseDetailZeit.push(value);
    },
    setKenngroesseDetailUw: (state, action: PayloadAction<{
      kenngroesseName: string,
      kategorieName: string;
      liste_headerArray: Array<colNameType>;
      liste_horizentalArray: Array<number>;
      liste_vertikalArray: Array<number>;
      min_allNumber: number;
      pqIndexArray: Array<Array<pqIndexResult>>;
      isOld: boolean
    }>) => {
      const value: pqIndexResultForKenngroesse = {
        kenngroesse: action.payload.kenngroesseName,
        kategorie: action.payload.kategorieName,
        liste_header: action.payload.liste_headerArray,
        liste_horizental: action.payload.liste_horizentalArray,
        liste_vertikal: action.payload.liste_vertikalArray,
        min_all: action.payload.min_allNumber,
        pqIndex: action.payload.pqIndexArray,
        isOld: action.payload.isOld
      };
      state.kenngroesseDetailUw.push(value);
    },
    setLoadingKenngroesseDetailUw: (state, action: PayloadAction<boolean>) => {
      state.loadingKenngroesseDetailUw = action.payload;
    },
    setLoadingKenngroesseDetailZeit: (state, action: PayloadAction<boolean>) => {
      state.loadingKenngroesseDetailZeit = action.payload;
    },
    deleteTabForKenngroesseDetailUw: (state, action: PayloadAction<string>) => {
      for (let index = 0; index < state.kenngroesseDetailUw.length; index++) {
        // eslint-disable-next-line security/detect-object-injection
        const element = state.kenngroesseDetailUw[index];
        if (element.kenngroesse == action.payload) {
          state.kenngroesseDetailUw.splice(index, 1)
        }
      }
    },
    deleteTabForKenngroesseDetailZeit: (state, action: PayloadAction<string>) => {
      for (let index = 0; index < state.kenngroesseDetailZeit.length; index++) {
        // eslint-disable-next-line security/detect-object-injection
        const element = state.kenngroesseDetailZeit[index];
        if (element.kenngroesse == action.payload) {
          state.kenngroesseDetailZeit.splice(index, 1)
        }
      }
    },
    setOldTabKenngroesse: (state) => {
      for (let index = 0; index < state.kenngroesseDetailUw.length; index++) {
        // eslint-disable-next-line security/detect-object-injection
        state.kenngroesseDetailUw[index].isOld = true;
      }
      for (let index = 0; index < state.kenngroesseDetailZeit.length; index++) {
        // eslint-disable-next-line security/detect-object-injection
        state.kenngroesseDetailZeit[index].isOld = true;
      }
    },
  }
});

export const selectKenngroesseDetailUw = (state: RootState): pqIndexResultForKenngroesse[] => state.kenngroesseDetailPqIndex.kenngroesseDetailUw;
export const selectKenngroesseDetailZeit = (state: RootState): pqIndexResultForKenngroesse[] => state.kenngroesseDetailPqIndex.kenngroesseDetailZeit;
export const selectLoadingKenngroesseDetailUw = (state: RootState): boolean => state.kenngroesseDetailPqIndex.loadingKenngroesseDetailUw;
export const selectLoadingKenngroesseDetailZeit = (state: RootState): boolean => state.kenngroesseDetailPqIndex.loadingKenngroesseDetailZeit;

export const getKenngroesseDetailUW =
  (messstelleParam: Array<messstelle>, kenngroesseParam: Array<kenngroesse>, startParam: Date, endeParam: Date, pqIndexMinParam: number, pqIndexMaxParam: number, grenzwertsatz: string, grupByUWParam: boolean, groupByKenngroessenkategorieParam: boolean, kenngroesseName: string) => (
    dispatch: AppDispatch): void => {

    const body = {
      start: startParam,
      end: endeParam,
      kenngroessen: kenngroesseParam,
      messstellen: messstelleParam,
      pqIndexMin: pqIndexMinParam,
      pqIndexMax: pqIndexMaxParam,
      grenzwertsatzName: grenzwertsatz
    }

    dispatch(setLoadingKenngroesseDetailUw(true))
    postJsonWithAuth("PQINDEXMESSSTELLEKENNGROESSE", { groupByUw: grupByUWParam, groupByKenngroessenkategorie: groupByKenngroessenkategorieParam }, body)
      .then((response: Array<Array<pqIndexResult>>) => {

        const kenngroesseList: Array<colNameType> = [];
        const tempMinHorizentalList: Array<number> = [];
        const tempMinVertikalList: Array<number> = [];
        let tempMinMessstellenAll = 10;
        let tempMinKenngroesseAll = 10;

        response.forEach(rows => {
          let tempMin = rows[0].value === null || rows[0].value === undefined ? 10 : rows[0].value;
          rows.forEach(row => {
            kenngroesseList.push({ name: row.col, col: row.col })
            if (row.value !== null && row.value !== undefined) {
              if (tempMin > row.value) {
                tempMin = row.value
              }
            }
          })
          tempMinVertikalList.push(tempMin)
          if (tempMin !== null && tempMin !== undefined) {
            if (tempMinMessstellenAll > tempMin) {
              tempMinMessstellenAll = tempMin;
            }
          }
        })

        kenngroesseList.sort((a, b) => a.name.localeCompare(b.name))
        const filterdKenngroesseList: Array<colNameType> = kenngroesseList.filter(function (elem, pos, self) {
          return self.findIndex((x) => (
            x.name === elem.name && x.col === elem.col
          )) == pos
        })

        filterdKenngroesseList.forEach(kenngroesseElem => {
          const initData = response[0][0];
          let tempMin = 11;
          if (kenngroesseElem.col == initData.col) {
            tempMin = initData.value;
          }
          response.forEach(rows => {
            rows.forEach(row => {
              if (kenngroesseElem.col == row.col) {
                if (row.value !== null && row.value !== undefined) {
                  if (tempMin > row.value) {
                    tempMin = row.value
                  }
                }
              }
            })
          })
          tempMinHorizentalList.push(tempMin)
          if (tempMin !== null && tempMin !== undefined) {
            if (tempMinKenngroesseAll > tempMin) {
              tempMinKenngroesseAll = tempMin;
            }
          }
        })
        dispatch(setKenngroesseDetailUw({
          kenngroesseName: kenngroesseName,
          kategorieName: "uw",
          liste_headerArray: filterdKenngroesseList,
          liste_horizentalArray: tempMinHorizentalList,
          liste_vertikalArray: tempMinVertikalList,
          min_allNumber: tempMinMessstellenAll < tempMinKenngroesseAll ? tempMinMessstellenAll : tempMinKenngroesseAll,
          pqIndexArray: response,
          isOld: false
        }));

      })
      .catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
      }).finally(() => dispatch(setLoadingKenngroesseDetailUw(false)));
  };

export const getKenngroesseDetailZeit =
  (messstelleParam: Array<messstelle>, kenngroesseParam: Array<kenngroesse>, startParam: Date, endeParam: Date, pqIndexMinParam: number, pqIndexMaxParam: number, grenzwertsatz: string, grupByUWParam: boolean, groupByKenngroessenkategorieParam: boolean, kenngroesseName: string) => (
    dispatch: AppDispatch): void => {

    const body = {
      start: startParam,
      end: endeParam,
      kenngroessen: kenngroesseParam,
      messstellen: messstelleParam,
      pqIndexMin: pqIndexMinParam,
      pqIndexMax: pqIndexMaxParam,
      grenzwertsatzName: grenzwertsatz
    }

    dispatch(setLoadingKenngroesseDetailZeit(true))
    postJsonWithAuth("PQINDEXKENNGROESSEZEIT", { groupByUw: grupByUWParam, groupByKenngroessenkategorie: groupByKenngroessenkategorieParam }, body)
      .then((response: Array<Array<pqIndexResult>>) => {

        const kwList: Array<colNameType> = [];
        const tempMinHorizentalList: Array<number> = [];
        const tempMinVertikalList: Array<number> = [];
        let tempMinMessstellenAll = 10;
        let tempMinZeitAll = 10;

        response.forEach(rows => {
          let tempMin = rows[0].value === null || rows[0].value === undefined ? 10 : rows[0].value;
          rows.forEach(row => {
            const dateTemp: Date = new Date(row.col);
            const convertWeekNumber = convertDateToWeekNumber(dateTemp);
            const yearOfWeekNumber = dateTemp.getFullYear();
            const colElem: colNameType = { name: convertWeekNumber.toString().length > 1 ? "KW " + "(" + yearOfWeekNumber + ") " + convertWeekNumber : "KW " + "(" + yearOfWeekNumber + ") " + "0" + convertWeekNumber, col: row.col }
            kwList.push(colElem)
            if (row.value !== null && row.value !== undefined) {
              if (tempMin > row.value) {
                tempMin = row.value
              }
            }
          })
          tempMinVertikalList.push(tempMin)
          if (tempMin !== null && tempMin !== undefined) {
            if (tempMinMessstellenAll > tempMin) {
              tempMinMessstellenAll = tempMin;
            }
          }
        })

        kwList.sort((a, b) => a.name.localeCompare(b.name))
        const filterdKwList: Array<colNameType> = kwList.filter(function (elem, pos, self) {
          return self.findIndex((x) => (
            x.name === elem.name && x.col === elem.col
          )) == pos
        })

        filterdKwList.forEach(zeitElem => {
          const initData = response[0][0];
          let tempMin = 11;
          const dateTempInit = initData.col;
          if (zeitElem.col == dateTempInit) {
            tempMin = initData.value;
          }
          response.forEach(rows => {
            rows.forEach(row => {
              const dateTempCol = row.col;
              if (zeitElem.col == dateTempCol) {
                if (row.value !== null && row.value !== undefined) {
                  if (tempMin > row.value) {
                    tempMin = row.value
                  }
                }
              }
            })
          })
          tempMinHorizentalList.push(tempMin)
          if (tempMin !== null && tempMin !== undefined) {
            if (tempMinZeitAll > tempMin) {
              tempMinZeitAll = tempMin;
            }
          }
        })

        dispatch(setKenngroesseDetailZeit({
          kenngroesseName: kenngroesseName,
          kategorieName: "zeit",
          liste_headerArray: filterdKwList,
          liste_horizentalArray: tempMinHorizentalList,
          liste_vertikalArray: tempMinVertikalList,
          min_allNumber: tempMinMessstellenAll < tempMinZeitAll ? tempMinMessstellenAll : tempMinZeitAll,
          pqIndexArray: response,
          isOld: false
        }));

      })
      .catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
      }).finally(() => dispatch(setLoadingKenngroesseDetailZeit(false)));
  };


export const {
  setKenngroesseDetailZeit,
  setKenngroesseDetailUw,
  setLoadingKenngroesseDetailUw,
  setLoadingKenngroesseDetailZeit,
  deleteTabForKenngroesseDetailZeit,
  deleteTabForKenngroesseDetailUw,
  setOldTabKenngroesse
} = kenngroesseDetailPqIndexSlice.actions;

export default kenngroesseDetailPqIndexSlice.reducer;